import { render, staticRenderFns } from "./quickLink.vue?vue&type=template&id=639cef9c&scoped=true&"
import script from "./quickLink.vue?vue&type=script&lang=ts&"
export * from "./quickLink.vue?vue&type=script&lang=ts&"
import style0 from "./quickLink.vue?vue&type=style&index=0&id=639cef9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639cef9c",
  null
  
)

export default component.exports